import { useMemo } from "react";
import TaskTableRows from "./TaskTableRows";

const TaskItem = ({
  budget,
  canAddTask,
  canEditBudget,
  canAddTask1,
  canEditTask,
  canDeleteTask,
  OpenModalAdd,
  OnEditBudget,
  OpenModalTAllocation,
  OpenModalEdit,
  OpenModalRemove,
}) => {
  const { totalHours, totalCost } = useMemo(() => {
    const tasks = budget?.tasks || [];
    return {
      totalHours: tasks.reduce(
        (sum, t) => sum + (parseFloat(t?.hours_spent) || 0),
        0
      ),
      totalCost: tasks.reduce(
        (sum, t) => sum + (parseFloat(t?.cost_spent) || 0),
        0
      ),
    };
  }, [budget.tasks]);

  return (
    <div className="row g-3 align-items-center">
      <div className="col-md-10">
        <span className="budget-name">
          BD{String(budget.bid).padStart(3, "0")} - {budget.budget_name}
        </span>
      </div>

      {(canAddTask || canEditBudget) && (
        <div className="col-md-2 d-flex justify-content-end">
          <div className="dropdown">
            <button
              className="btn btn-sm"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="bi bi-three-dots-vertical"></i>
            </button>

            <ul className="dropdown-menu">
              {canAddTask && (
                <li onClick={() => OpenModalAdd(budget.bid)}>
                  <a className="dropdown-item" href="#">
                    Add New Task
                  </a>
                </li>
              )}

              {canEditBudget && (
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      OnEditBudget(budget);
                    }}
                  >
                    Edit Budget
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      )}

      {/* Task Table */}
      <table className="table custom-table">
        <thead>
          <tr>
            <th>Task ID</th>
            <th className="w-25">Task</th>
            <th>Allocations</th>
            <th>Time Consumed (hrs)</th>
            <th className="text-end">Cost Consumed ($)</th>
            {(canEditTask || canDeleteTask) && <th>Actions</th>}
          </tr>
        </thead>

        <tbody>
          <TaskTableRows
            budget={budget}
            canAddTask1={canAddTask1}
            canEditTask={canEditTask}
            canDeleteTask={canDeleteTask}
            OpenModalTAllocation={OpenModalTAllocation}
            OpenModalEdit={OpenModalEdit}
            OpenModalRemove={OpenModalRemove}
          />

          <tr>
            <td colSpan="3" className="text-start">
              <span className="budget-total">Total</span>
            </td>
            <td className="text-start">
              <span className="budget-total">{totalHours.toFixed(2)} hrs</span>
            </td>
            <td className="text-end">
              <span className="budget-total">${totalCost.toFixed(2)}</span>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <hr className="hr-dotted" />
    </div>
  );
};

export default TaskItem;
